import { render, staticRenderFns } from "./ProductGridComponent.vue?vue&type=template&id=1a1dbcad&scoped=true&"
import script from "./ProductGridComponent.vue?vue&type=script&lang=ts&"
export * from "./ProductGridComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ProductGridComponent.vue?vue&type=style&index=0&id=1a1dbcad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1dbcad",
  null
  
)

export default component.exports